module.exports = __webpack_public_path__ + "static/media/branding-logo.5166e14a.png";